import { navigationNamespace } from "@/store/modules/navigation";
import { patientNamespace } from "@/store/modules/patient";
import { userNamespace } from "@/store/modules/user";
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { Colors } from "../../components/shared/util";
@Component({})
export default class Instructions extends Vue {
  // Set to "help1" if open by default is preferred
  selected = "help1";

  @Getter("area", patientNamespace)
  area!: string;

  @Getter("config", patientNamespace)
  config!: any;

  @Getter("changeLog", patientNamespace)
  changeLog!: any;

  @Getter("user", userNamespace)
  user!: any;

  @Getter("system", userNamespace)
  systemInfo!: Record<string, any>;

  @Getter("darkMode", navigationNamespace)
  dark!: boolean;

  get helpTabs() {
    return this.config.help.tabs.filter((f: any) => f.description != null);
  }

  get currentYear() {
    return new Date().getFullYear();
  }

  get versionDisplay() {
    return this.systemInfo.version == null || this.systemInfo.version === ""
      ? ""
      : this.systemInfo.version;
  }

  get buildDate() {
    return this.systemInfo.buildDate == null || this.systemInfo.buildDate === ""
      ? ""
      : this.systemInfo.buildDate;
  }

  get runTime() {
    const startDateString: string =
      this.systemInfo.startDate == null || this.systemInfo.startDate === ""
        ? ""
        : this.systemInfo.startDate;
    if (startDateString == "") return startDateString;
    else {
      const startDate = new Date(startDateString);
      const nowDate = new Date();
      return this.datesToDiffString(startDate, nowDate);
    }
  }

  datesToDiffString(start: Date, end: Date): string {
    let delta = Math.abs(end.getTime() - start.getTime()) / 1000;
    const days = Math.floor(delta / 86400);
    delta -= days * 86400;
    const hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;
    const minutes = Math.floor(delta / 60) % 60;
    delta -= minutes * 60;
    const seconds = delta % 60;
    const times: string[] = [];
    if (days > 0) {
      times.push(days.toString() + " day" + (days > 1 ? "s" : ""));
    }
    if (hours > 0) {
      times.push(hours.toString() + " hour" + (hours > 1 ? "s" : ""));
    }
    if (minutes > 0) {
      times.push(minutes.toString() + " minute" + (minutes > 1 ? "s" : ""));
    }
    if (hours < 1) {
      times.push(
        Math.floor(seconds).toString() + " second" + (seconds > 1 ? "s" : "")
      );
    }
    return times.join(", ");
  }

  get systemName() {
    return this.systemInfo.system == null || this.systemInfo.system === ""
      ? ""
      : this.systemInfo.system;
  }

  get siteRev() {
    return this.systemInfo.siteRev == null || this.systemInfo.siteRev === ""
      ? ""
      : this.systemInfo.siteRev;
  }
  get userQuickname() {
    const names: string[] = this.user.name.split(",");
    return names.length > 1 ? names[1] : this.user.name;
  }

  get isMobileThin() {
    return (
      this.$vuetify.breakpoint.smAndDown && this.$vuetify.breakpoint.width < 420
    );
  }

  get ifuLink() {
    return "docs/" + this.area + "IFU.pdf";
  }

  get isAdmin() {
    return this.user.isAdmin === true;
  }

  styleForObject(o: any): string {
    if (o.completed === true) return Colors.TestGreen;
    else if (o.completed === false && o.required === false)
      return Colors.Orange;
    else if (o.completed === false && o.required === true) return Colors.Red;
    else return "";
  }

  iconForObject(o: any): string {
    if (o.completed === true) return "check_circle";
    else if (o.completed === false && o.required === false)
      return "report_problem";
    else if (o.completed === false && o.required === true)
      return "error_outline";
    else return "error_outline";
  }

  colorForChangeType(a: number) {
    if (a === 1) return Colors.Blue;
    else if (a == 2) return !this.dark ? "#000" : "#fff";
    else return !this.dark ? Colors.LogoBlue : Colors.Yellow;
  }
}
